import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { CurrentCustomerModule } from '@common/current-customer/current-customer.module';
import { CurrentUserModule } from '@common/current-user/current-user.module';
import { CustomerSelectorModule } from '@common/customer-selector/customer-selector.module';
import { ToolbarComponent } from './toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatTooltipModule,
    CustomerSelectorModule,
    CurrentCustomerModule,
    CurrentUserModule,
  ],
  declarations: [ToolbarComponent],
  exports: [ToolbarComponent],
})
export class NavigationToolbarModule {}
